export default __webpack_public_path__ + "static/media/Hand_right.eae56a12.svg";